// Bundle Builder panel: live count, tier badge, next-tier nudge, item rows,
// totals, CTA. Money truth = /cart.js allocations; simulated preview only
// before real allocations exist. Only lines flagged _bundle=true count —
// mirrors the bundle-builder-tier-discount function's eligibility exactly.
(function () {
  'use strict';

  var panel = document.querySelector('[data-bb-panel]');
  var root = document.querySelector('[data-bb-root]');
  if (!panel || !root) return;

  var cfgEl = document.querySelector('[data-bb-tier-config]');
  var tiers = window.BBTiers.parse(cfgEl);
  var shipCfg = { min: 0, label: 'FREE SHIPPING' };
  try {
    var cfg = JSON.parse(cfgEl.textContent);
    shipCfg.min = Number(cfg.freeShipMinQty) || 0;
    if (cfg.freeShipLabel) shipCfg.label = cfg.freeShipLabel;
  } catch (e) { /* freeship display off */ }
  var els = {
    inner: panel.querySelector('.bb-panel__inner'),
    heading: panel.querySelector('.bb-panel__heading'),
    count: panel.querySelector('[data-bb-count]'),
    badge: panel.querySelector('[data-bb-tier-badge]'),
    shipNote: panel.querySelector('[data-bb-ship-note]'),
    progress: panel.querySelector('[data-bb-progress]'),
    body: panel.querySelector('[data-bb-panel-body]'),
    totals: panel.querySelector('[data-bb-totals]'),
    subtotal: panel.querySelector('[data-bb-subtotal]'),
    total: panel.querySelector('[data-bb-total]'),
  };
  var emptyHtml = els.body.innerHTML;

  // Edits in flight (queued through cartRequest). While > 0, skip re-renders:
  // intermediate responses are stale vs. the clicks the user already made —
  // only the FINAL response repaints, so optimistic qty never flickers back.
  var pendingOps = 0;

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function isBundleItem(item) { return item.properties && item.properties._bundle === 'true'; }

  function bundleAllocCents(item) {
    return (item.line_level_discount_allocations || []).reduce(function (sum, a) {
      var title = (a.discount_application && a.discount_application.title) || '';
      return title.indexOf('BUNDLE') === 0 ? sum + a.amount : sum;
    }, 0);
  }

  function render(cart) {
    if (pendingOps > 0) return; // stale mid-queue snapshot — final response renders
    var items = (cart.items || []).filter(isBundleItem);
    var n = items.reduce(function (s, i) { return s + i.quantity; }, 0);
    els.count.textContent = n;

    if (!items.length) {
      els.body.innerHTML = emptyHtml;
      els.badge.hidden = true;
      els.totals.hidden = true;
      renderProgress(n);
      return;
    }

    // Money truth is ALWAYS /cart.js — never simulate totals. The % badge shows
    // only when a real BUNDLE allocation exists AND matches the declared tier.
    var subtotal = items.reduce(function (s, i) { return s + i.original_line_price; }, 0);
    var realDiscount = items.reduce(function (s, i) { return s + bundleAllocCents(i); }, 0);
    var finalTotal = items.reduce(function (s, i) { return s + i.final_line_price; }, 0);
    var declared = window.BBTiers.active(tiers, n);
    var showPct = null;

    if (realDiscount > 0) {
      var effectivePct = (realDiscount / subtotal) * 100;
      if (declared && Math.abs(effectivePct - declared.pct) <= 0.5) {
        showPct = declared.pct; // display config matches cart truth
      } else {
        console.warn('[bundle-builder] tier DRIFT: displayed config says ' +
          (declared ? declared.pct : 'none') + '%, cart allocation is ' +
          effectivePct.toFixed(2) + '% — suppressing % claim (sync checklist!)');
      }
    } else if (declared) {
      // Tier threshold met but no BUNDLE allocation: another non-combinable
      // discount won arbitration (e.g. B1G1 Dress) or the function is down.
      // CONFLICT state — never claim a % that checkout won't honor.
      console.warn('[bundle-builder] CONFLICT: ' + n + ' eligible items but no BUNDLE ' +
        'allocation in /cart.js — % claim suppressed, showing real totals.');
    }

    els.badge.hidden = showPct === null;
    if (showPct !== null) els.badge.textContent = showPct + '% OFF UNLOCKED';

    els.body.innerHTML = items.map(function (i) {
      return '<div class="bb-item" data-key="' + esc(i.key) + '">' +
        '<img class="bb-item__thumb" src="' + esc(i.image) + '" alt="" loading="lazy">' +
        '<div><p class="bb-item__title">' + esc(i.product_title) + '</p>' +
        (i.variant_title ? '<span class="bb-item__variant">' + esc(i.variant_title) + '</span>' : '') +
        '</div>' +
        '<div class="bb-item__controls"><span class="bb-item__qty">' +
        '<button type="button" data-bb-qty="-1" aria-label="Decrease">−</button>' +
        '<span class="bb-item__qty-value">' + i.quantity + '</span>' +
        '<button type="button" data-bb-qty="1" aria-label="Increase">+</button></span>' +
        '<button type="button" class="bb-item__remove" data-bb-remove>Remove</button></div>' +
        '</div>';
    }).join('');

    els.totals.hidden = false;
    var discounted = finalTotal < subtotal;
    els.subtotal.hidden = !discounted;
    els.subtotal.textContent = money(subtotal);
    els.total.textContent = money(finalTotal);
    renderProgress(n);
  }

  function renderProgress(n) {
    // Free shipping status line (unlocked / nudge) — display config from section
    if (els.shipNote && shipCfg.min > 0) {
      if (n >= shipCfg.min) {
        els.shipNote.hidden = false;
        els.shipNote.textContent = '🚚 ' + shipCfg.label + ' unlocked';
      } else {
        els.shipNote.hidden = true;
      }
    }
    var nx = window.BBTiers.next(tiers, n);
    if (!nx) {
      els.progress.innerHTML = n > 0 ? 'Top tier unlocked!' : '';
      return;
    }
    var need = nx.minQty - n;
    var reward = esc(nx.pct) + '% OFF';
    if (shipCfg.min > 0 && n < shipCfg.min && nx.minQty >= shipCfg.min) {
      reward += ' + ' + esc(shipCfg.label);
    }
    els.progress.innerHTML = 'Add ' + need + ' more → ' + reward +
      '<div class="bb-progress-bar"><div class="bb-progress-bar__fill" style="width:' +
      Math.min(100, Math.round((n / nx.minQty) * 100)) + '%"></div></div>';
  }

  function refresh() {
    return window.BBTiers.cartRequest('/cart.js', undefined, 3)
      .then(render)
      .catch(function (e) { console.error('[bundle-builder] cart fetch', e); });
  }

  function changeLine(key, quantity) {
    pendingOps++;
    return window.BBTiers.cartRequest('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (cart) {
        pendingOps--;
        if (pendingOps > 0) return; // more edits queued — let the last one paint
        render(cart);
        // Header bubble only — no theme-wide cart-update emit (see grid JS note)
        document.querySelectorAll('.m-cart-count-bubble').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('m:hidden', !cart.item_count);
        });
      })
      .catch(function (e) {
        pendingOps--;
        // Transient junk response (bot-check interstitial, cart lock) — /cart.js is truth
        console.warn('[bundle-builder] cart change fell back to refresh:', e.message);
        if (pendingOps === 0) refresh(); // reconcile optimistic UI with server truth
      });
  }

  panel.addEventListener('click', function (e) {
    var row = e.target.closest('.bb-item');
    if (row) {
      var qtyBtn = e.target.closest('[data-bb-qty]');
      var qtyEl = row.querySelector('.bb-item__qty-value');
      var current = qtyEl ? Number(qtyEl.textContent) : 0;
      if (qtyBtn) {
        var target = Math.max(0, current + Number(qtyBtn.dataset.bbQty));
        // Optimistic: paint the target NOW so (a) the tap feels instant despite
        // the >=900ms serialized cart queue, and (b) a rapid second tap reads
        // the updated value instead of re-sending the same stale quantity.
        if (qtyEl) qtyEl.textContent = target;
        if (target === 0) row.style.opacity = '0.5';
        changeLine(row.dataset.key, target);
        return;
      }
      if (e.target.closest('[data-bb-remove]')) {
        row.style.opacity = '0.5'; // instant feedback while the removal queues
        changeLine(row.dataset.key, 0);
        return;
      }
    }
    // Mobile: heading toggles the bottom sheet
    if (e.target.closest('.bb-panel__heading') && window.matchMedia('(max-width: 1024px)').matches) {
      els.inner.classList.toggle('is-expanded');
    }
  });

  document.addEventListener('bb:cart:changed', function (e) {
    if (e.detail && e.detail.cart) render(e.detail.cart);
    else refresh();
  });

  refresh();
})();
